import Base from './base'
import api from '../api/v1'
import { downloadFile } from '../utils'
import { decamelize } from 'humps'

const base = new Base('containers')

const actions = {
  getCounters({ commit, rootGetters }) {
    const params = rootGetters['tables/getTableParameters']('containers').params
    api.getContainersCounters(params).then(resp => {
      commit('SET_COUNTERS', resp.data)
    })
  },
  releaseContainer({ commit, dispatch }, { item }) {
    const release = () => {
      commit('SET_PROCESSING', true)
      return api.releaseContainer(item.id)
        .then(response => {
          dispatch('snackbar/showSnackbar', {
            message: [response.data?.success || 'Kontener zwolniony.']
          }, { root: true })
          dispatch('singleView/getSingleViewEntity', { id: item.id, tableName: 'containers' }, { root: true })
          dispatch('getItems')
          dispatch('layout/closeDialog', null, { root: true })
        })
        .finally(() => {
          commit('SET_PROCESSING', false)
        })
    }

    return dispatch('layout/setDialog', {
      data: {
        component: 'ConfirmationDialog',
        text: 'Zwolnij kontener',
        description: 'Czy na pewno chcesz zwolnić kontener?',
        tableName: 'containers',
        callback: release
      }
    }, { root: true })
  },
  exportContainersSpreadsheet ({ state, commit, rootState, rootGetters }) {
    commit('SET_PROCESSING', true)
    const containerIds = state.selectedItems

    const containerHeaders = rootState.tables.containers.parameters
      .filter(header => header.show && !['select', 'actions'].includes(header.name))
      .map(header => decamelize(header.name))

    const { order, filters, departmentId } = rootGetters['tables/getTableParameters']('containers').params

    api.exportContainersSpreadsheet({
      departmentId,
      containerHeaders,
      containerIds,
      order,
      filters
    }).then((resp) => {
      const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'text/csv' }))
      downloadFile(url, `Kontenery ${state.dateRange}`)
      commit('UNSELECT_ALL_ITEMS')
    })
      .finally(() => {
        commit('SET_PROCESSING', false)
      })
  },
}

base.actions = {
  ...base.actions,
  ...actions
}

export default base
